import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RankingsService {

  private rankingsSource = new BehaviorSubject<Ranking[]>(null);
  currentRankings = this.rankingsSource.asObservable();

  private rankingSource = new BehaviorSubject<Ranking>(null);
  currentRanking = this.rankingSource.asObservable();

    constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, private toastrService: ToastrService, private router: Router,) { }

  getRankings() {
    this.http.get(`${this.baseUrl}api/Rankings`, {observe: 'response'}).subscribe(response => {
      if (response.status === 200) {
        let rankings: any = response.body;
        this.setRankings(rankings);
      }
    });
  }
  
  getRanking(rankingId: number) {
    this.http.get(`${this.baseUrl}api/Rankings/${rankingId}`, {observe: 'response'}).subscribe(response => {
      if (response.status === 200) {
        let ranking: any = response.body;
        this.setRanking(ranking);
      }
    });
  }

  deleteRanking(rankingId: number) {
    this.http.delete(`${this.baseUrl}api/Rankings/${rankingId}`, { observe: 'response' }).subscribe(response => {
      if (response.status === 200) {
        //let ranking: any = response.body;
        //this.setRanking(ranking);
        this.getRankings();
      }
    })
  }

  submitRanking(rankingId: number, action: string) {
    this.http.post(`${this.baseUrl}api/Rankings/${rankingId}/workflow`, { workflowAction: action }, {observe: 'response'}).subscribe(response => {
      if (response.status === 200) {
          this.toastrService.success(`Successfully executed the '${action}' workflow for this Ranking!`, 'Success:', {
          positionClass: 'toast-top-full-width',
          closeButton: true,
          });
          this.router.navigate(['/', 'seasonal-ranking']);
      }
    });
  }

  setRankings(rankings: Ranking[]) {
    this.rankingsSource.next(rankings);
  }

  setRanking(ranking: Ranking) {
    this.rankingSource.next(ranking);
  }

}

export interface Ranking {
  rankingId: number,
  permitYearId: number,
  permitYear: number,
  rankingName: string,
  rankingDate: Date,
  effectiveDate: Date,
  endDate: Date,
  projectFacilityCount: number,
  rankingStatusId: number,
  rankingStatusName: string
}
